/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_launchpad__account_modal_signin = /** @type {(inputs: {}) => string} */ () => {
	return `Anmelden`
};

const en_launchpad__account_modal_signin = /** @type {(inputs: {}) => string} */ () => {
	return `Sign up`
};

const es_launchpad__account_modal_signin = /** @type {(inputs: {}) => string} */ () => {
	return `Suscribirse`
};

const fr_launchpad__account_modal_signin = /** @type {(inputs: {}) => string} */ () => {
	return `S’inscrire`
};

const it_launchpad__account_modal_signin = /** @type {(inputs: {}) => string} */ () => {
	return `Iscriviti`
};

const nl_launchpad__account_modal_signin = /** @type {(inputs: {}) => string} */ () => {
	return `Inschrijven`
};

const pt_launchpad__account_modal_signin = /** @type {(inputs: {}) => string} */ () => {
	return `Inscrever-se`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__account_modal_signin = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.launchpad__account_modal_signin(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("launchpad__account_modal_signin", locale)
	if (locale === "de") return de_launchpad__account_modal_signin(inputs)
	if (locale === "en") return en_launchpad__account_modal_signin(inputs)
	if (locale === "es") return es_launchpad__account_modal_signin(inputs)
	if (locale === "fr") return fr_launchpad__account_modal_signin(inputs)
	if (locale === "it") return it_launchpad__account_modal_signin(inputs)
	if (locale === "nl") return nl_launchpad__account_modal_signin(inputs)
	return pt_launchpad__account_modal_signin(inputs)
};